import axios from "@/plugins/axios";

export default {
    actions: {
        fetchSaleServiceMonthlyStat(context, searchItem) {
            let url = "sale_service_monthlies?page="  + searchItem.page

            if (!context.state.saleServiceMonthlyStat.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.byAmount) {
                url = url + '&order[amount]=desc'
            } else {
                url = url + '&order[incomeAmount]=desc'
            }

            if (searchItem.before) {
                url = url + '&date[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&date[after]=' + searchItem.after
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleServiceMonthlyStat', data)
                })
                .catch((err) => {
                    console.log(err)

                })
        },
    },
    mutations: {
        updateSaleServiceMonthlyStat(state, data) {
            state.saleServiceMonthlyStat = data
            state.saleServiceMonthlyStat.isNeedFetch = false
        },
    },
    state: {
        saleServiceMonthlyStat: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getSaleServiceMonthlyStat(state) {
            return state.saleServiceMonthlyStat.models
        },
        getSaleServiceMonthlyStatTotalCount(state) {
            return state.saleServiceMonthlyStat.totalItems
        },
    },
}
